import { Link } from "react-router-dom";
import early from "../../assets/images/activity/early.jpg";
import primary from "../../assets/images/activity/primary.jpg";
import middle from "../../assets/images/activity/middle.jpg";

const Scholatic = () => {
  return (
    <section className="faculty pb-80 pt-40">
      <div className="container">
        <div className="section-heading text-center">
          <div
            className="flex-align d-inline-flex gap-8 mb-16"
            data-aos="fade-down"
            data-aos-duration="700"
          >
            <h5 className="text-main-600 mb-0">Scholastic Programme</h5>
          </div>
          <h2
            className="mb-24"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="100"
          >
            Board and Curriculum
          </h2>
        </div>

        <div className="row gy-4">
          {/* Early Years */}
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="0"
          >
            <div className="scale-hover-item bg-white rounded-16 p-12 h-100 box-shadow-md">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={early}
                  alt="NPS Kudlu Students"
                  loading="lazy"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-2">Early Years</h4>
                <p>
                  Our Early Years Scholastic Programme is designed to nurture
                  curiosity, creativity, and a love for learning in young
                  children.
                </p>
                <div className="flex-between gap-8 pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                  <Link
                    to="/scholastic-program#early"
                    className="flex-align gap-8 text-main-600 hover-text-decoration-underline transition-1 fw-semibold"
                  >
                    Know More <i className="ph ph-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Primary Years */}
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="scale-hover-item bg-white rounded-16 p-12 h-100 box-shadow-md">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={primary}
                  alt="Student Learning"
                  loading="lazy"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-2">Primary Years</h4>
                <p>
                  The Primary Years Scholastic Programme builds on early
                  learning with a structured and engaging academic environment.
                </p>
                <div className="flex-between gap-8 pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                  <Link
                    to="/scholastic-program#primary"
                    className="flex-align gap-8 text-main-600 hover-text-decoration-underline transition-1 fw-semibold"
                  >
                    Know More <i className="ph ph-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Middle Years */}
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="scale-hover-item bg-white rounded-16 p-12 h-100 box-shadow-md">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={middle}
                  alt="NPS Kudlu Classrooms"
                  loading="lazy"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-2">Middle Years</h4>
                <p>
                  The Middle Years Programme bridges primary and secondary
                  education, fostering critical thinking, inquiry, and
                  application of knowledge.
                </p>
                <div className="flex-between gap-8 pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                  <Link
                    to="/scholastic-program#middle"
                    className="flex-align gap-8 text-main-600 hover-text-decoration-underline transition-1 fw-semibold"
                  >
                    Know More <i className="ph ph-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Scholatic;
